const copyUrlToClipboard = (url) => {
    const tempDocElement = document.createElement("textarea")
    document.body.appendChild(tempDocElement)
    tempDocElement.value = url
    tempDocElement.select()
    document.execCommand("copy")
    document.body.removeChild(tempDocElement)
}

const checkValueSize = (value) => {
    return value.length < 2 ? "0".concat(value) : value
}

const checkSkillPointsSize = (value) => {
    let response = value
    if (value.length < 2) {
        response = "00".concat(value)
    } else if (value.length === 2) {
        response = "0".concat(value)
    }
    return response
}

const updateSkillLevelLength = (levels) => {
    return levels
        .map((level) => {
            return checkValueSize(level.toString())
        })
        .toString()
        .replace(/[,]+/g, "")
}

const generateBuildLink = (
    className,
    level,
    thirdClassLevel,
    cooldown,
    skillPoints,
    skillsLevels
) => {
    const URL = "https://aika-simulator.netlify.app/shared-build/"
    const encondedURL = btoa(
        className.concat(
            checkValueSize(level.toString()),
            checkValueSize(thirdClassLevel.toString()),
            checkValueSize(cooldown.toString()),
            checkSkillPointsSize(skillPoints.toString()),
            updateSkillLevelLength(skillsLevels)
        )
    )
    copyUrlToClipboard(URL.concat(encondedURL))
}

export default generateBuildLink
